import { __t } from '../i18n/t'
import { mapPath } from '../constants'
import getChainId from './getChainId'

type LegacyDataProvider = (type: string, resourceName: string, params: any) => Promise<any>

const LIST_TYPES = ['GET_LIST', 'GET_MANY', 'GET_MANY_REFERENCE']

// Segmento literal "undefined" ou "null" no caminho: alguém interpolou um id que ainda não existia.
const HAS_NULLISH_SEGMENT = /(^|\/)(undefined|null)(\/|$)/

/**
 * Barra a requisição que já nasce com caminho inválido, antes de ir ao backend: eram ≈290
 * 400 por mês em `chains/null/...` e `chains/undefined/...`.
 *
 * - O caminho tem o marcador `chainId` e não há rede escolhida (admin em TODAS, ou perfil sem
 *   rede): o provider trocaria por "undefined". Lista devolve vazio; o resto rejeita.
 * - O resource já traz "/undefined/" ou "/null/": nunca é um endpoint real.
 *
 * `GET_MANY` ignora o `mapPath` (getMany.ts usa o resource cru), então a checagem também.
 */
export const withRequestGuard = (
  provider: LegacyDataProvider,
  chainIdOf: () => string | null | undefined = getChainId,
): LegacyDataProvider => (type, resourceName, params) => {
  const path = (type === 'GET_MANY' ? resourceName : (mapPath[resourceName] || resourceName)) || ''
  const noChain = path.includes('chainId') && !chainIdOf()

  if (noChain || HAS_NULLISH_SEGMENT.test(path)) {
    return LIST_TYPES.includes(type)
      ? Promise.resolve({ data: [], total: 0 })
      : Promise.reject(new Error(noChain ? __t('Selecione uma rede') : __t('Endereço de requisição inválido')))
  }

  return provider(type, resourceName, params)
}
